@switch (value) {
  @case (0) {
    <span class="badge rounded-pill bg-light border border-success text-success fw-bolder" style="font-size: 11px">{{
      displayName
    }}</span>
  }
  @case (1) {
    <span class="badge rounded-pill text-bg-success border border-success" style="font-size: 11px">{{
      displayName
    }}</span>
  }
  @default {
    <span class="badge rounded-pill bg-light border border-secondary text-secondary" style="font-size: 11px">{{
      displayName
    }}</span>
  }
}
